import authClient from "authClient";
import jwt_decode from "jwt-decode";
import config from "config";
import store from "store";

export const getUser = () => {
  const userStr = store.getState().userSession.user; //get the actual user name
  return userStr || "";
};

export const getUsername = () => {
  const username = store.getState().userSession.username; //get the unique username with which user logs in
  return username || "";
};

export const getToken = () => {
  return store.getState().userSession.token || null;
};

export const extractRoleFromJWTToken = () => {
  const role = jwt_decode(authClient.token).resource_access[
    "unified-engagement-platform"
  ]["roles"][0];
  return role ? role.toUpperCase() : "";
};

export const getBusinessUnit = () => {
  const { BUSINESS_UNIT } = config;
  return BUSINESS_UNIT;
};

export const getGroup = () => {
  return store.getState().userSession.group || null;
};

export const getRefreshToken = () => {
  return store.getState().userSession.refreshToken || null;
};

export const setToken = (token) => {
  if (token) {
    sessionStorage.setItem("token", token);
  }
};

export const clearTimers = (timers) => {
  timers.forEach((timer) => clearTimeout(timer));
};

export const getFileObjectFromUrl = (fileUrl) => {
  if (fileUrl.length) {
    const fileUrlAsArray = fileUrl.split("/");
    const name = fileUrlAsArray[fileUrlAsArray.length - 1];
    const label = name.length && name.includes(".") ? name.split(".")[0] : name;
    const format = name.length && name.includes(".") ? name.split(".")[1] : "";
    const formatInUpperCase = format.toUpperCase();
    return {
      name,
      label,
      formatInUpperCase,
      fileUrl,
    };
  }
  return null;
};
